module.exports = __webpack_public_path__ + "img/art.b95cff26.svg";